import * as api from '@/api';

export default {
    data() {
        return {
            site: {
                name: '',
                address1: null,
                address2: null,
                city: null,
                state: null,
                zip: null,
                notes: null,
                tags: {},
            },

            submitPending: false,
            submitError: null,
        };
    },

    methods: {
        async createSite() {
            if (!this.$refs.siteForm.validate()) {
                return;
            }

            this.submitPending = true;
            this.submitError = null;

            const company = this.$store.state.company.id;
            const res = await api.createSite({ ...this.site, company });

            this.submitPending = false;

            if (res.error) {
                this.submitError = res.error.message;
                this.$awn.alert('Failed to create site');
                return null;
            }

            this.submitError = null;
            this.$awn.success('New site added');

            this.$store.dispatch('company/fetchOverview');

            return res.body;
        },
    },
};